
import { Component } from 'vue-property-decorator';
import VOpeningHourBundle from '@/components/shared/domain/VOpeningHoursBundle.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { OpeningHour } from '@/interfaces/models/OpeningHour';

@Component({
  components: { VOpeningHourBundle },
})
export default class OpeningHourForm extends mixins(StackedForm) {
  public $refs!: {
    openingHour: InstanceType<typeof VOpeningHourBundle> & {
      validate: () => Promise<boolean>;
      hours: OpeningHour[];
      getHours: () => OpeningHour[];
      setHours: (hours: OpeningHour[], overwrite?: boolean) => void;
    };
  };

  public async validate(): Promise<boolean> {
    return this.$refs.openingHour?.validate();
  }

  public isEmpty() {
    return !this.$refs.openingHour.getHours()?.length;
  }

  public getData() {
    return {
      openingHours: this.$refs.openingHour.getHours(),
    };
  }

  public setData(data: OpeningHour[]) {
    this.$refs.openingHour.setHours(data, true);
  }

  public mounted(): void {
    if (this.initialValues) {
      // @ts-ignore
      this.$refs.openingHour.setHours(this.initialValues.openingHours);
    }
  }
}
